module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.woff
// module id = 366
// module chunks = 0